import Pagination from './Pagination';

const searchResults = document.getElementById('search-results');

if (searchResults !== null) {
    new Pagination().registerPagination('#search-results');
}
